import { Component } from '@angular/core'

import { LeaseDetailService } from '@modules/private/lease/data/services/view/lease-detail.service'

@Component({
	selector: 'app-lease-analysis',
	templateUrl: './lease-analysis.component.html',
	styleUrls: ['./lease-analysis.component.scss'],
})
export class LeaseAnalysisComponent {
	constructor(public leaseDetailService: LeaseDetailService) {}

	/**
	 * Indica si el lease ya tiene un Excel de análisis de riesgo importado.
	 * Mientras NO haya datos, mostramos sólo el card de upload — las sub-pestañas
	 * sólo aparecen cuando el Excel se ha procesado.
	 *
	 * Sirve para PM y PF: PF no trae `eeffPeriods` (sin EEFF), por eso el check
	 * abarca también pilares de la calculadora y flujos del titular.
	 */
	get hasImportedData(): boolean {
		const r = this.leaseDetailService?.ratiosData as any
		const c = this.leaseDetailService?.calculatorData as any
		const hasEeff = Array.isArray(r?.eeffPeriods) && r.eeffPeriods.length > 0
		const hasPillars = Array.isArray(c?.pillars) && c.pillars.length > 0
		const hasFlows = !!this.leaseDetailService?.holderBankFlows
		return hasEeff || hasPillars || hasFlows
	}

	/**
	 * Tipo de persona del análisis. Viene del Excel parseado (lo persiste el
	 * backend en calculator/ratios). Default 'PM' para análisis legacy sin el flag.
	 */
	get personType(): 'PM' | 'PF' {
		const svc = this.leaseDetailService as any
		return svc?.calculatorData?.personType ?? svc?.ratiosData?.personType ?? 'PM'
	}

	/**
	 * EEFF Anual y Ratios anuales sólo aplican a Persona Moral. Para Persona
	 * Física esas pestañas se ocultan (PF no entrega estados financieros).
	 */
	get showFinancials(): boolean {
		return this.personType !== 'PF'
	}

	/** F-026 · Con más de un obligado solidario la pestaña los nombra en plural. */
	get jointObligorsTabLabel(): string {
		return (this.leaseDetailService?.jointObligorsBankFlows?.length ?? 0) > 1 ? 'Flujos de los obligados solidarios' : 'Flujos del obligado solidario'
	}

	//* F-026 · Los tres métodos que se probaban aquí (`refresh`, `getById`, `loadLeaseData`) no existen en el servicio:
	//* tras importar no se volvía a pedir nada y la pantalla seguía en el cargador hasta recargar la página.
	onExcelImported(): void {
		this.leaseDetailService.refreshRiskAnalysis()
	}
}
